const page   = require('../../../../../components/page/page')
const clientSaleDt = require('./clientSale-dt')
import clientSalePage       from "./clientSale-page.html";

/****************ELEMENTS*****************/
var HTMLwasSelected  = false

//insert the page  on the body
function HTMLselect(detail){ 
	
	HTMLwasSelected = true

	//load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", clientSalePage)

   clientSaleDt.start({"dest":"clientSale", "elem":"dt", "act":"select", "entity":"clientSale"})

}/*init*/

/****************ELEMENTS*****************/
export function start(detail){ 
   if(!HTMLwasSelected) {HTMLselect(detail)}
	 obj[detail.act].start(detail)
}

const obj = {
      show:  { start: (detail)=>{  page.start(detail)     }},

}/**/


